import Trustpilot from './Trustpilot';

export default Trustpilot;
